<template lang="html">
  <visc-layout>
    <div class="main-ed-header-light custom-login-page-header">
      <a id="logo_3" class="fr-widget fr-svg fr3_logo_3 fr-link" href="/">
            <div class="fr-svg-inner">
              <!--?xml version="1.0" encoding="utf-8"?-->
              <!-- Generator: Adobe Illustrator 19.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 74.7 23.5" xml:space="preserve" enable-background="new 0 0 74.7 23.5">
      <g>
      <g>
      <path class="st0" d="M3.7,16.1c0.1,2.5,1.3,4.3,4.1,4.3c1.6,0,2.8-0.7,3.7-1.5l1,2c-1.3,1.1-2.9,1.8-5.1,1.8    c-4.3,0-6.3-3.1-6.3-7.3c0-4.3,2.4-7.4,6.2-7.4c3.7,0,5.3,2.6,5.3,5.7c0,0.9-0.1,1.8-0.3,2.6H3.7z M10.3,14    c0.1-0.3,0.1-0.6,0.1-0.9c0-1.8-1-3.1-2.9-3.1c-2.2,0-3.4,1.6-3.6,3.9H10.3z"></path>
      <path class="st0" d="M26.8,22.2h-2.6v-1.5c-0.9,1-2.1,1.7-3.8,1.7c-3.4,0-5.6-2.7-5.6-7.3c0-4.6,2.3-7.2,5.6-7.2    c1.6,0,2.9,0.7,3.8,1.7V3.2h2.6V22.2z M21.3,20.2c1.3,0,2.4-0.7,3-1.5v-6.9c-0.6-0.8-1.7-1.5-3-1.5c-2.4,0-3.8,1.9-3.8,5    C17.5,18.3,19,20.2,21.3,20.2z"></path>
      <path class="st0" d="M32.1,8.2v8.3c0,2.3,0.9,3.5,2.9,3.5c1.8,0,3-1.3,3.4-2.8v-9h2.6v14h-2.6v-2c-0.9,1.3-2.4,2.2-4.4,2.2    c-3.1,0-4.6-2-4.6-5.5V8.2H32.1z"></path>
      <path class="st0" d="M43.9,22.2v-14h2.6v2.1C47.2,8.8,48.1,8,49.7,8c0.8,0,1.6,0.3,2.2,0.7l-0.5,2.4c-0.6-0.4-1.3-0.6-2-0.6    c-1.5,0-2.4,1.2-3,3v8.8H43.9z"></path>
      <path class="st0" d="M55.3,2.8c0.9,0,1.5,0.4,1.5,1.4c0,1.1-0.7,1.5-1.5,1.5c-0.9,0-1.6-0.4-1.6-1.5C53.7,3.2,54.4,2.8,55.3,2.8z     M54,22.2v-14h2.6v14H54z"></path>
      <path class="st0" d="M65,7.9c3.8,0,6.4,2.8,6.4,7.4c0,4.6-2.5,7.3-6.4,7.3c-3.8,0-6.3-2.8-6.3-7.3C58.6,10.6,61.2,7.9,65,7.9z     M65,20.2c2.3,0,3.8-1.8,3.8-4.9c0-3.2-1.5-5-3.8-5c-2.3,0-3.8,1.8-3.8,5C61.2,18.4,62.7,20.2,65,20.2z"></path>
      </g>
      <path class="st0" d="M73.4,5.3l-1.7,1.4c-0.4,0.4-0.4,0.4-0.8,0l-1.7-1.4c-0.2-0.2-0.3-0.4-0.3-0.6V2c0-0.5,0.4-0.9,0.9-0.9h2.8   c0.5,0,0.9,0.4,0.9,0.9v2.6C73.7,4.9,73.6,5.1,73.4,5.3z"></path>
      </g>
      </svg>
            </div>
          </a>
    </div>

    <!-- BEGIN #content -->
    <main id="content" v-if="typeof $route.query.go === 'undefined'">


        <!-- BEGIN .container -->
        <div class="container">

            <section id="login-page">

                <section id="students-view-page">

                    <div class="ed-custom-login-page skola2030-colors">

                        <div class="ed-custom-login-page-data-block ed-custom-no-border">
                            <div class="skola2030-logo">
                                <img src="/material/img/foreign/Skola2030_Logo-01__2_.jpg" alt="Skola2030" />
                            </div>
                        </div>

                        <!-- <div class="alert alert-danger">{{ Session::has('message') ? Session::get('message') : false }}</div> -->

                        <h1>{{ 'login.survey_login_big_text' | lang }}</h1>

                        <div class="ed-custom-login-page-data-block" v-html="$options.filters.lang('login.about-visc')"></div>
                        
                        
                        <div class="ed-custom-login-page-data-block-bottom visc-logo-svg-block">
                            <img src="/material/img/foreign/Screen_Shot_2018-05-29_at_09.29.15_with_border.png" alt="" />
                        </div>
                    </div>


                </section>


            </section>

            <!-- END .container -->
        </div>

        <!-- BEGIN #content -->
    </main>

    <main v-else id="content">

        <!-- BEGIN .container -->
        <div class="container">

            <div class="ed-custom-login-page ed-custom-login-page-small">

                <div class="ed-custom-login-page-data-block"><!-- Some texts and logos that we'll get from client --></div>

                <div class="alert alert-danger" v-if="$root.session.has">{{ $root.session.message }}</div>

                <!-- <h2>@lang('login.text_to_fill_survey_login_with')</h2> -->
                <h2>{{ 'login.visc_pass_info' | lang }}</h2>

                <p class="ed-custom-login-info-tbl">
                {{ 'login.visc_school' | lang }}<span>{{ customData['school'] }}</span><br/>

                {{ 'login.visc_roll' | lang }} <span>{{ customData['formated_type'] }}</span><br />

                    <font v-if="typeof customData['class_level'] !== 'undefined' && customData['class_level'] !== null">
                        {{ 'login.visc_class' | lang }}<span>{{ customData['class_level'] }}{{ 'login.visc_class_dot' | lang }}</span><br />
                    </font>

                    <font v-if="customData['school_leader'] == true">
                      {{ 'login.visc_name_surname' | lang }}
                      <span>{{ customData['name'] }} {{ customData['surname'] }}</span><br />
                    </font>
                </p>

                <div class="ed-custom-login-page-buttons">
                    <a href="/skola2030?continue" class="btn">{{ 'login.visc_fill_poll' | lang }}</a>
                    <a href="/skola2030?cancel" class="btn btn-link">{{ 'login.visc_cancel' | lang }}</a>
                </div>

            </div>
        </div>
    </main>

  </visc-layout>
</template>

<script>
import viscLayout from '../../layouts/custom/Visc.vue';
import insertGoogleAnalytics from '../../mixins/insert-google-analytics.js';
import * as common_functions from '../../common_functions.js';

export default {
  name: 'Skola2030',
  components: {
    viscLayout,
  },
  mixins: [insertGoogleAnalytics],
  data() {
    return {
      customData: {},
    };
  },
  created() {
    this.customData = window.customData;

    this.insertGoogleAnalytics();

    ga('create', 'UA-47475097-4', 'auto');
    ga('send', 'pageview');
  },
  methods: {
    pollOpenLink () {
      var opt = jQuery(".poll-code-login").val();
      window.location = window.location.origin + "/poll/" + opt;
    }
  },
}
</script>